import { TimeEntryCategory } from '../timeEntryCategory/timeEntryCategory';
import { User } from '../user/user';

interface HasOwner {
  id: string;
  ownerType: string;
  label: string;
}

export class TimeEntryOwner implements HasOwner {
  id: string;
  ownerType: string;
  label: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.ownerType = payload.ownerType;
      this.label = payload.label;
    }
  }
}

export class TimeEntry {
  id: string;
  user: User;
  taskId: string;
  owner: TimeEntryOwner;
  startDateTime: string;
  endDateTime: string;
  duration: number;
  pauseDuration: number;
  note: string;
  category: TimeEntryCategory;
  createdBy: User;
  createdDateTime: string;
  lastModifiedDateTime: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      if (payload.user) {
        this.user = new User(payload.user);
      }
      this.startDateTime = payload.startDateTime;
      if (payload.owner) {
        this.owner = new TimeEntryOwner(payload.owner);
      }
      this.taskId = payload.taskId;
      this.endDateTime = payload.endDateTime;
      this.duration = payload.duration;
      this.pauseDuration = payload.pauseDuration;
      this.note = payload.note;
      if (payload.category) {
        this.category = new TimeEntryCategory(payload.category);
      }
      if (payload.createdBy) {
        this.createdBy = new User(payload.createdBy);
      }
      this.createdDateTime = payload.createdDateTime;
      this.lastModifiedDateTime = payload.lastModifiedDateTime;
    }
  }

  static createTimeEntries(result: Array<any>): TimeEntry[] {
    const timeEntries = new Array<TimeEntry>();
    if (result) {
      result.map((timeEntry) => {
        timeEntries.push(new TimeEntry(timeEntry));
      });
    }
    return timeEntries;
  }
}

export class TimeEntryInput {
  id: string;
  userId: string;
  taskId: string;
  ownerId: string;
  ownerType: string;
  startDateTime: string;
  endDateTime: boolean;
  pauseDuration: number;
  categoryId: string;
  note: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.userId = payload.userId;
      this.taskId = payload.taskId;
      this.ownerId = payload.ownerId;
      this.ownerType = payload.ownerType;
      this.startDateTime = payload.startDateTime;
      this.endDateTime = payload.endDateTime;
      this.pauseDuration = payload.pauseDuration;
      this.categoryId = payload.categoryId;
      this.note = payload.note;
    }
  }
}
